import { createFileRoute } from '@tanstack/react-router';
import ProgramsPage from '@/features/programs/ProgramsPage';
import { programsSearchSchema } from '@/features/programs/programs-search.schema';

export const Route = createFileRoute('/programas/')({
  validateSearch: programsSearchSchema,
  component: () => <ProgramsPage />,
});
